import styled from 'styled-components'
import { BqButton } from '@beeq/react'

export const PaginationControlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--bq-spacing-xs);
`

export const PaginationButton = styled(BqButton)`
  --bq-button--small-padding: var(--bq-spacing-s);
  --bq-button--small-height: var(--bq-spacing-xl);
  
  &::part(button) {
    --bq-button--border-radius: var(--bq-radius--s);
    width: var(--bq-spacing-xl);
  }
`
